type SubscribeUrlConfig = {
  hide_at?: string
}

type SubscribeUrlAccessParams = {
  enabled: boolean
  value: string | number | boolean | null | undefined
}

/**
 * @description
 * - enabled가 true이고 value가 없는 경우: enabled 값을 그대로 반환
 * - enabled가 true이고 value가 있는 경우: hide_at 날짜가 현재 날짜보다 미래인 경우에만 true를 반환
 * - enabled가 false이거나 value가 없거나 형식이 올바르지 않은 경우: false를 반환
 */
export const checkSubscribeUrlAccess = ({ enabled, value }: SubscribeUrlAccessParams): boolean => {
  if (!enabled) {
    return false
  }

  // value가 없으면 enabled 값만으로 판단
  if (!value || typeof value !== 'string') {
    return enabled
  }

  try {
    const config = JSON.parse(value) as SubscribeUrlConfig
    if (!config.hide_at) {
      return enabled
    }

    const hideAtDate = new Date(config.hide_at)
    const now = new Date()

    return now < hideAtDate
  } catch {
    return enabled
  }
}
